"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8914],{

/***/ 28914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionTextBlocks": function() { return /* binding */ SectionTextBlocks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    padding: "$96 0",
    backgroundColor: "$darkThemeBackground",
    color: "$white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "$96",
    containerSpace: "medium",
    "@md": {
        gap: "$120"
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading04",
    textAlign: "center"
});
const TextBlocksWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$96",
    "@md": {
        maxWidth: "$aboutPageContentWidth",
        gridTemplateColumns: "1fr 1fr",
        justifyItems: "center",
        columnGap: "$96",
        rowGap: "$textBlocksRowGap"
    }
});
const BlockTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h3", {
    projectFont: "heading07",
    marginBottom: "$24"
});
const BlockText = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "body03",
    color: "$white_06"
});
const SectionTextBlocks = (param)=>{
    let { title , textBlocks  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "NO_MARGIN",
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextBlocksWrap, {
                children: textBlocks && (textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.length) > 0 && textBlocks.map((textBlock, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            textBlock.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockTitle, {
                                children: textBlock.title
                            }),
                            textBlock.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockText, {
                                children: textBlock.text
                            })
                        ]
                    }, "".concat(textBlock.title, "-").concat(index)))
            })
        ]
    });
};


/***/ })

}]);